<template>
  <p style="font-size: 30px; text-align: center; margin-top: 20px; font-weight: bold;">{{ responseData.message }}</p>
</template>

<script>
export default {
  props: ['responseData']
}
</script>